import {
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  CircularProgress,
} from "@mui/material";

import useMedicalCompleteLock from "../../../hooks/useMedicalCompleteLock";
import { useQueryParams } from "../../../hooks/useQueryParams";
import MedicalCompleteLockNotice from "../../global/MedicalCompleteLockNotice";
import PaginationControlsV2 from "../../global/PaginationControlsV2";

import { Row } from "./Row";
import TopMenu from "./TopMenu";
import { APP_LIMIT, APP_OFFSET } from "./utils/consts";

export default function AppointmentsTable({
  activeBills,
  appointments,
  appointmentsCount,
  caseInfo,
  handleApptDelete,
  handleProviderApptEdit,
  handleUploadDocument,
  loading,
  setProvider,
  setProviderDetailDisplay,
}) {
  const { filters, updateFilter } = useQueryParams();
  const { isAppointmentLocked } = useMedicalCompleteLock();
  const appointmentLocked = isAppointmentLocked(caseInfo);
  const urlLimit = Number.parseInt(filters?.get("limit") ?? "", APP_LIMIT);
  const urlOffset = Number.parseInt(filters?.get("offset") ?? "", APP_OFFSET);
  const effectiveLimit = Number.isFinite(urlLimit) && urlLimit > 0 ? urlLimit : APP_LIMIT;
  const effectiveOffset = Number.isFinite(urlOffset) && urlOffset >= 0 ? urlOffset : APP_OFFSET;
  const currentPage = Math.floor(effectiveOffset / effectiveLimit) + 1;

  function handlePageChange(_, value) {
    updateFilter("offset", value ? (value - 1) * effectiveLimit : 0);
  }

  return (
    <TableContainer
      component={Paper}
      data-id="collapsible-table"
      className="max-h-[80vh] overflow-auto"
    >
      <TopMenu caseInfo={caseInfo} />
      <MedicalCompleteLockNotice locked={appointmentLocked} className="mx-4 mb-2 mt-2" />
      {loading ? (
        <div className="mt-2 pb-2">
          <div className="mx-auto w-fit">
            <CircularProgress color="secondary" />
          </div>
        </div>
      ) : (
        <>
          <Table aria-label="collapsible table" stickyHeader>
            <TableHead>
              <TableRow data-id="collapsible-table-headers">
                <TableCell align="left" className="font-bold">
                  Provider&nbsp;Location
                </TableCell>
                <TableCell align="left" className="font-bold">
                  Type
                </TableCell>
                <TableCell align="left" className="font-bold">
                  Date&nbsp;&&nbsp;Time
                </TableCell>
                <TableCell align="center" className="font-bold">
                  Status
                </TableCell>
                <TableCell align="center" className="font-bold">
                  Documents
                </TableCell>
                <TableCell />
              </TableRow>
            </TableHead>
            <TableBody>
              {appointments.map((row, index) => {
                return (
                  <Row
                    key={index}
                    row={row}
                    activeBills={activeBills}
                    caseInfo={caseInfo}
                    handleApptDelete={handleApptDelete}
                    handleProviderApptEdit={handleProviderApptEdit}
                    setProvider={setProvider}
                    setProviderDetailDisplay={setProviderDetailDisplay}
                    handleUploadDocument={handleUploadDocument}
                  />
                );
              })}
            </TableBody>
          </Table>
          <div className="my-4 flex w-full items-center justify-center">
            <PaginationControlsV2
              currentPage={currentPage}
              handleChange={handlePageChange}
              resultCount={appointmentsCount}
              resultLimit={effectiveLimit}
            />
          </div>
        </>
      )}
    </TableContainer>
  );
}
